import { SearchOutlined } from "@ant-design/icons";
import { Button, Card, Col, Input, Row, Space, Table, Tooltip } from "antd";
import { cloneDeep, forEach, get, map } from "lodash";
import React, { FC, useEffect, useRef, useState } from "react";
import Highlighter from "react-highlight-words";

import { filterPayload } from "../../calendarUtils";
import { formatCreateDate  } from "@utils/helpers";
import dashboardService from "@services/dashboard.service";
import { useCalenderViewStore } from "@stores/useCalenderViewStore";
import "./drillDownViewTableForMonth.scss";
import { TableLocale } from "@components/noDataFound";

const TablePreloader = () => {
  return (
    <Row className="tableWrapper">
      <Col span={24}>
        <div className="table-preloader">
          {map(Array.from(Array(6).keys()), (item: any) => {
            return (
              <div className="table-preloader__row" key={"row_" + item}>
                {map(Array.from(Array(8).keys()), (item: any) => {
                  return (
                    <div key={"col_" + item} className="table-preloader__row__column">
                      <div className="table-preloader__row__column__sub-title shimmerBG"></div>
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
        <div className="pagination_preload">
          <div className="pagination_text_preloader shimmerBG"></div>
        </div>
      </Col>
    </Row>
  );
};

const DrillDownViewTableForMonth: FC<any> = ({setMonthlyAppointmentDetails}) => {
  const [data, setData] = useState<any>();
  const [drilldownMonthData, setDrillDownMonthData] = useState<any>();
  const [columnSearchInfo, setColumnSearchInfo] = useState({});
  const [column, setColumn] = useState<any>();
  const [monthAppointmentDetails, setMonthAppointmentDetails] = useState([]);
  const selectedDateCalender = useCalenderViewStore((state) => state.selectedDateCalender);
  const balanceOfMonth = useCalenderViewStore((state) => state.balanceOfMonthFlag);
  const [drillDownLoader , setDrillDownLoader] = useState<boolean>(false);
  const monthFilter = useCalenderViewStore((state) => state.monthFilter);
  const [totalAppointmentAmount, setTotalAppointmentAmount] = useState(0);

  const highlighterDiv = (text: any, searchWord: any) => {
    return (
      <Tooltip placement="topLeft" title={text ? text.toString() : ""}>
        <Highlighter highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }} searchWords={[searchWord]} autoEscape textToHighlight={text ? text.toString() : ""} />
      </Tooltip>
    );
  };

  useEffect(() => {
    console.log("DrillDownViewTableForMonth.useEffect1");
    setDrillDownLoader(true)
    let filters = filterPayload(monthFilter);
    dashboardService.fetchCalenderMonthViewAppointmentDetails(selectedDateCalender.format("YYYY-MM-DD"), balanceOfMonth, filters).subscribe({
      next: (v) => {
        setMonthAppointmentDetails(v.data.data.result);
        setMonthlyAppointmentDetails(v.data.data.result);
        setDrillDownLoader(false);
      },

      error: (e) => {
        console.log(e);
        setDrillDownLoader(false);
      },
    });
  }, [balanceOfMonth, monthFilter, selectedDateCalender, setMonthlyAppointmentDetails]);

  useEffect(() => {
    console.log("DrillDownViewTableForMonth.useEffect2");
    const tempcoldata: any = [];
    forEach(monthAppointmentDetails[0], (appointmentsProperties: any) => {
      let appObj = {
        title: "",
        dataIndex: "",
        key: "",
        width: 160,
        ellipsis: {
          showTitle: false,
        },
        render: (text: any) => (
          <Tooltip placement="topLeft" title={text}>
            {text}
          </Tooltip>
        ),
        sorter: (a: any, b: any) => {
          a[appObj.dataIndex]=a[appObj.dataIndex]?a[appObj.dataIndex]:"";
          b[appObj.dataIndex]=b[appObj.dataIndex]?b[appObj.dataIndex]:"";
          return a[appObj.dataIndex].localeCompare(b[appObj.dataIndex]);
        },
      };
      appObj.title = appointmentsProperties.label;
      appObj.dataIndex = appointmentsProperties.columnName;
      appObj.key = appointmentsProperties.columnName;
      tempcoldata.push(appObj);
    });
    setColumn(tempcoldata);
    const tempdrilldownMonthData: any = [];
    let totalAppointmentSum = 0 ;
    forEach(monthAppointmentDetails, (singleAppointment) => {
      if (singleAppointment) {
        let appObj: any = {};
        forEach(singleAppointment, (appointmentProperties: any) => {
          if(appointmentProperties.columnName === "appointment_amount"){
            totalAppointmentSum = totalAppointmentSum +  appointmentProperties.value;
          }
          appObj[appointmentProperties.columnName] = appointmentProperties.value;
        });
        tempdrilldownMonthData.push(appObj);
      }
    });
    setTotalAppointmentAmount(totalAppointmentSum);
    setDrillDownMonthData(tempdrilldownMonthData);
    setData(tempdrilldownMonthData);
  }, [monthAppointmentDetails]);

  const applyColumnSearch = (columnName: any, text: any) => {
    text = text ? text : get(columnSearchInfo, [columnName], "");
    if (text !== "") {
      let tempdrillDownMonthData = data.filter((data: any) => {
        if (data[columnName]) {
          return data[columnName].toString().toLowerCase().includes(text.toLowerCase());
        } else {
          return false;
        }
      });
      setDrillDownMonthData(tempdrillDownMonthData);
    } else {
      setDrillDownMonthData(data);
    }
  };

  const inputref = useRef<any>(null);
  const _xyz: Array<{}> = map(cloneDeep(column), (dataInfo: any) => {
    return {
      ...dataInfo,

      filterDropdown: ({ confirm }: any) => (
        <div style={{ padding: "10px" }}>
          <Input
            style={{ marginBottom: 8, display: "block" }}
            value={get(columnSearchInfo, dataInfo.dataIndex, "")}
            ref={inputref}
            onChange={(e) => {
              e.preventDefault();
              setColumnSearchInfo({
                ...columnSearchInfo,
                [dataInfo.dataIndex]: e.target.value,
              });
            }}
            onKeyUp={(e) => {
              if (e.keyCode === 13) {
                e.preventDefault();
                setColumnSearchInfo({
                  [dataInfo.dataIndex]: get(
                    columnSearchInfo,
                    dataInfo.dataIndex,
                    ""
                  ),
                });
                applyColumnSearch(dataInfo.dataIndex, "");
                confirm({ closeDropdown: true });
              }
            }}
          />
          <Space>
            <Button
              type="primary"
              icon={<SearchOutlined />}
              size="small"
              style={{ width: 90 }}
              onClick={(e) => {
                e.stopPropagation();
                setColumnSearchInfo({
                  [dataInfo.dataIndex]: get(columnSearchInfo, dataInfo.dataIndex, ""),
                });
                applyColumnSearch(dataInfo.dataIndex, "");
                confirm({ closeDropdown: true });
              }}
            >
              Search
            </Button>
            <Button
              onClick={() => {
                setColumnSearchInfo({ [dataInfo.dataIndex]: "" });
                applyColumnSearch("", "");
                confirm({ closeDropdown: true });
              }}
              size="small"
              style={{ width: 90 }}
            >
              Reset
            </Button>
          </Space>
        </div>
      ),
      filterIcon:
        dataInfo.dataIndex === "action"
          ? null
          : () => (
              <SearchOutlined
                style={{
                  color: get(columnSearchInfo, dataInfo.dataIndex, "") !== "" ? "#EF6D2A" : undefined,
                }}
              />
            ),
      render:
        dataInfo.dataIndex === "date"
          ? dataInfo.render
          : dataInfo.dataIndex === "cost"
          ? (text: any, record: any) => highlighterDiv("$ " + text, get(columnSearchInfo, dataInfo.dataIndex, ""))
          : dataInfo.dataIndex=== "appointment_amount" ? (text: any, record: any) => highlighterDiv(`$ ${text}`, get(columnSearchInfo, dataInfo.dataIndex, ""))
          :["appointment_created_date","appointment_date","first_proc_date", "birth_date"].includes(dataInfo.dataIndex)
          ?(text: any, record: any) => highlighterDiv(formatCreateDate (text), get(columnSearchInfo, dataInfo.dataIndex, "")) 
          :(text: any, record: any) => highlighterDiv(text, get(columnSearchInfo, dataInfo.dataIndex, "")),
      onFilter: (value: any, record: any) => (record[dataInfo.dataIndex] ? record[dataInfo.dataIndex].toString().toLowerCase().includes(value.toLowerCase()) : ""),
      onFilterDropdownOpenChange: (visible:any) => {
        if (visible) {
          setTimeout(() => inputref.current?.select(), 100);
        }
      }
    };
  });

  return (
    drillDownLoader ? <TablePreloader/> : <div>
      <Card>
      <div className="totalAppointmentAmount"><div>Total Appointment Amount <div className="totalAppointmentAmount__subtitle">(Includes broken appointments) </div></div><div className="totalAppointmentAmount__value">: $ {totalAppointmentAmount.toLocaleString()}</div></div>
        <Row>
          <Col span={24}>
            <div className="appointment-table">
              <Table
                bordered={true}
                pagination={{
                  defaultPageSize: 5,
                  showSizeChanger: true,
                  pageSizeOptions: ["5", "10", "15", "20", "25", "30"],
                }}
                // loading={loading}
                columns={_xyz}
                dataSource={drilldownMonthData}
                locale={TableLocale}
                scroll={{ x: 1200 }}
                // size="small"
              />
            </div>
          </Col>
        </Row>
      </Card>
    </div>
  );
};

export default DrillDownViewTableForMonth;